import { render } from "./Darna Mall.vue?vue&type=template&id=bc77ed00&scoped=true"
const script = {}

import "./Darna Mall.vue?vue&type=style&index=0&id=bc77ed00&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bc77ed00"

export default script